var map = {
	"./bn.json": 57581,
	"./de.json": 95894,
	"./en.json": 44174,
	"./es.json": 46725,
	"./fr.json": 94605,
	"./gu.json": 46813,
	"./hi.json": 53134,
	"./id.json": 35176,
	"./it.json": 83672,
	"./kn.json": 10412,
	"./pt.json": 37741,
	"./ro.json": 22354,
	"./ta.json": 77610,
	"./te.json": 63718,
	"./th.json": 67549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35679;